// src/walletConnect.js
import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultConfig,
  RainbowKitProvider,
  darkTheme,
  lightTheme
} from '@rainbow-me/rainbowkit';
import { WagmiProvider } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useColorMode } from '@chakra-ui/react';

const config = getDefaultConfig({
  appName: 'Lotoro',
  appUrl: 'https://lotoro.co',
  projectId: process.env.REACT_APP_WALLETCONNECT_PROJECT_ID,
  chains: [bsc],
  ssr: false,
  autoConnect: true,

  walletConnect: {
    metadata: {
      name: 'Lotoro',
      description: 'Decentralized Lottery App',
      url: 'https://lotoro.co',
      icons: ['https://lotoro.co/lotoro-logo.png'],
    },
  },
});

const queryClient = new QueryClient();

function RainbowKitWithTheme({ children }) {
  const { colorMode } = useColorMode();
  return (
    <RainbowKitProvider
      modalSize="compact"
      theme={colorMode === 'light' ? lightTheme() : darkTheme()}
    >
      {children}
    </RainbowKitProvider>
  );
}

export function WalletProvider({ children }) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitWithTheme>
          {children}
        </RainbowKitWithTheme>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
